import type { FaireProductEntity } from "../../entity_types/product";

export const p_bwqcqbuzbq: FaireProductEntity = {
  token: "p_bwqcqbuzbq",
  type: "product",
  name: "100% Pure Extra Virgin Olive Oil – Cold-Pressed (240mL)",
  brandToken: "b_wc2q3m3rxc",
  brandName: "Hongar Farms",
  imageUrl:
    "https://cdn.faire.com/fastly/8c2ef81a90a07f2aadb3336cf18fd39d93829a5331d68f2229028cee4d3572ce.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.69,
  description:
    "Hongar Farms Extra Virgin Olive Oil is a premium 100% pure cold-pressed olive oil. This rich and nutty non-GMO oil is full of nutrients including omega-3 and omega-9 fatty acids. Drizzle this delicious olive oil over salads fresh bread and appetizers or use for medium-heat cooking. \n\nSpecs:\n-Fluid Size: 240 mL (8.1 fl oz)\n-Height: 10 in | Width: 2.25 in | Depth: 2.25 in\n-Weight: 1.25 lbs\n-Color: Golden with Herb Particulates\n-Taste: Bold Garlic and Earthy Rosemary\n\nUsage:\nCelebrations, Memorial Day, Easter, Mother’s Day, Spring & Summer Parties, Dinner Parties, Grilling, Charcuterie Boards, Healthy Cooking Oils, Italian Cooking, Gift Giving\n\nNotes:\nAll Natural, No Preservatives, Small Batch, Made in the USA (Georgia), Fresh Ingredients, Infused Cooking Oil",
  tags: [],
  msrpDollars: 19.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:25.714Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
